import { Button, Checkbox, Col, Form, Input, InputNumber, Modal, Row, Select, Spin, Switch } from 'antd';
import _ from 'lodash';
import { useEffect, useMemo, useState } from 'react';
import { toast } from 'react-toastify';
import BreadCrumbs from '../../../../common/components/Breadcrumbs';
import { validateMessages } from '../../../../common/constants/common';
import { Page } from '../../../../common/constants/pageAction';
import { ISpsApiType } from '../../../../services/sps/apiType/apiType.model';
import { useAppSelector, useAppDispatch } from '../../../../store/app.hooks';
import { getSpsApiTypeById, saveMappingSpsApiType, saveSpsApiType } from '../../../../store/sps/apiType/apiType.action';
import {
  clearSpsApiTypeGetById,
  clearSpsApiTypeMessages,
  spsApiTypeSelector,
} from '../../../../store/sps/apiType/apiType.reducer';
import { IAddSpsApiTypeProps } from './addApiType.model';
import { ILookup } from '../../../../services/common/common.model';
import {
  clearMultipleUpdateMessages,
  commonSelector,
} from '../../../../store/common/common.reducer';
import { getSpsApiGroupLookup, updateMultiple } from '../../../../store/common/common.action';
import { getObjectForUpdateMultiple } from '../../../../common/helperFunction';
import ApiTable from '../../APIsCall/ApiTable';
import { spsApiOauthV2Selector } from '../../../../store/sps/apiOauthV2/apiOauthV2.reducer';

const { Option } = Select;

const AddSpsApiTypeModal: React.FC<IAddSpsApiTypeProps> = (props) => {
  const spsApiType = useAppSelector(spsApiTypeSelector);
  const [ShowTableMNodal, setShowTableMNodal] = useState(false);
  const spsApis = useAppSelector(spsApiOauthV2Selector);
  const [IDs, setIDs] = useState([]);
  const [finalValue, setFinalValue] = useState(null);
  const [callApiObj, setCallApiObj] = useState({
    id: 0,
  });
  const dispatch = useAppDispatch();
  const commonLookups = useAppSelector(commonSelector);
  const { id, showModal, handleModalClose, refreshDataTable, isMultiple, valuesForSelection } =
    props;

  const isNew: boolean = id || isMultiple ? false : true;
  const title = useMemo(() => {
    return (
      <>
        {isNew ? 'Add ' : 'Edit '} <BreadCrumbs pageName={Page.SpsApiType} level={1} />
      </>
    );
  }, [isNew]);
  const submitButtonText = useMemo(() => {
    return isNew ? 'Save' : 'Update';
  }, [isNew]);

  const [form] = Form.useForm();

  let initialValues: ISpsApiType = {
    name: '',
    route: '',
    url: '',
    api_group_id: null,
    limit: null,
    base_urls: '',
    individual_field_mapping: false,
  };

  const onFinish = (values: any) => {
    const inputValues: ISpsApiType = {
      ...values,
      id: id ? +id : null,
    };
    setFinalValue(inputValues);
    if (!isMultiple) {
      dispatch(saveSpsApiType(inputValues));
    } else {
      const result = getObjectForUpdateMultiple(
        valuesForSelection,
        inputValues,
        spsApiType.search.tableName
      );
      if (result) {
        dispatch(updateMultiple(result));
      }
    }
  };

  const fillValuesOnEdit = async (data: ISpsApiType) => {
    if (data) {
      initialValues = {
        name: data.name,
        route: data.route,
        url: data.url,
        individual_field_mapping: data.individual_field_mapping,
        api_group_id: _.isNull(data.api_group_id) ? null : data.api_group_id,
        limit: _.isNull(data.limit) ? null : data.limit,
        base_urls: data.base_urls,
      };
      form.setFieldsValue(initialValues);
    }
  };

  useEffect(() => {
    if (spsApiType.save.messages.length > 0) {
      if (spsApiType.save.hasErrors) {
        toast.error(spsApiType.save.messages.join(' '));
      } else {
        if (spsApiType.save.data?.individual_field_mapping_available) {
          setCallApiObj({ id: id });
          setShowTableMNodal(true);
        } else {
          toast.success(spsApiType.save.messages.join(' '));
          handleModalClose();
          refreshDataTable();
        }
      }
      dispatch(clearSpsApiTypeMessages());
    }
  }, [spsApiType.save.messages]);

  useEffect(() => {
    if (spsApiType.saveMapping.messages.length > 0) {
      if (spsApiType.saveMapping.hasErrors) {
        toast.error(spsApiType.saveMapping.messages.join(' '));
      } else {
        toast.success(spsApiType.saveMapping.messages.join(' '));
        handleModalClose();
        refreshDataTable();
      }
      dispatch(clearSpsApiTypeMessages());
    }
  }, [spsApiType.saveMapping.messages]);

  useEffect(() => {
    if (commonLookups.save.messages.length > 0) {
      if (commonLookups.save.hasErrors) {
        toast.error(commonLookups.save.messages.join(' '));
      } else {
        toast.warn(commonLookups.save.messages.join(' '));
        handleModalClose();
      }
      dispatch(clearMultipleUpdateMessages());
    }
  }, [commonLookups.save.messages]);

  useEffect(() => {
    if (+id > 0 && spsApiType.getById.data) {
      const data = spsApiType.getById.data;
      fillValuesOnEdit(data);
    }
  }, [spsApiType.getById.data]);

  useEffect(() => {
    dispatch(getSpsApiGroupLookup());
    if (+id > 0) {
      dispatch(getSpsApiTypeById(+id));
    }
    return () => {
      dispatch(clearSpsApiTypeGetById());
    };
  }, [dispatch]);

  useEffect(() => {
    const deleteIDs = [];
    const Obj: any = {
      ...IDs
    };
    if(Obj.selectedIds !== undefined){
      const rowList = {
        ...Obj.selectedIds,
      };
      rowList.selectedRowList = rowList?.selectedRowList?.map((data) => data = data.split('-')[0]);
      rowList.selectedRowList = rowList?.selectedRowList?.map((data) => data = +data);
      spsApis.search.data.map((data1) => {
        if (!rowList.selectedRowList?.includes(data1.id))
          deleteIDs.push(data1.id);
      });
      const data: any = {
        id: id,
        sps_api_type: finalValue,
        oauth_ids: rowList.selectedRowList,
        delete_oauth_ids: deleteIDs
      };
      dispatch(saveMappingSpsApiType(data));
    }
  }, [IDs.length]);

  return (
    <>
      <Modal
        wrapClassName="custom-modal"
        title={title}
        centered
        visible={showModal}
        onCancel={handleModalClose}
        footer={false}
      >
        {spsApiType.getById.loading ? (
          <div className="spin-loader">
            <Spin spinning={spsApiType.getById.loading} />
          </div>
        ) : (
          <Form
            form={form}
            name="spsApiType"
            initialValues={initialValues}
            onFinish={onFinish}
            validateMessages={validateMessages}
          >
            <Row gutter={[30, 15]} className="form-label-hide">
              <Col xs={24} sm={12} md={8}>
                <div className="form-group m-0">
                  {isMultiple ? (
                    <Form.Item name={['checked', 'name']} valuePropName="checked" noStyle>
                      <Checkbox>Name</Checkbox>
                    </Form.Item>
                  ) : (
                    'Name'
                  )}
                  <Form.Item
                    name="name"
                    label="Name"
                    className="m-0"
                    rules={[{ required: !isMultiple, max: 255 }]}
                  >
                    <Input className="form-control" />
                  </Form.Item>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <div className="form-group m-0">
                  {isMultiple ? (
                    <Form.Item name={['checked', 'route']} valuePropName="checked" noStyle>
                      <Checkbox>Route</Checkbox>
                    </Form.Item>
                  ) : (
                    'Route'
                  )}
                  <Form.Item
                    name="route"
                    label="Route"
                    className="m-0"
                    rules={[{ required: !isMultiple, max: 255 }]}
                  >
                    <Input className="form-control" />
                  </Form.Item>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <div className="form-group m-0">
                  {isMultiple ? (
                    <Form.Item name={['checked', 'url']} valuePropName="checked" noStyle>
                      <Checkbox>URL</Checkbox>
                    </Form.Item>
                  ) : (
                    'URL'
                  )}
                  <Form.Item name="url" label="URL" className="m-0" rules={[{ max: 255 }]}>
                    <Input className="form-control" />
                  </Form.Item>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <div className="form-group m-0">
                  {isMultiple ? (
                    <Form.Item name={['checked', 'limit']} valuePropName="checked" noStyle>
                      <Checkbox>Limit</Checkbox>
                    </Form.Item>
                  ) : (
                    'Limit'
                  )}
                  <Form.Item name="limit" label="Limit" className="m-0" rules={[{ type: 'integer' }]}>
                    <InputNumber className="form-control w-100" min={1} />
                  </Form.Item>
                </div>
              </Col>
              {/* <Col xs={24} sm={12} md={8}>
                <div className="form-group m-0">
                  {isMultiple ? (
                    <Form.Item name={['checked', 'base_urls']} valuePropName="checked" noStyle>
                      <Checkbox>Base Urls</Checkbox>
                    </Form.Item>
                  ) : (
                    'Base Urls'
                  )}
                  <Form.Item
                    name="base_urls"
                    label="Base Urls"
                    className="m-0"
                    rules={[{ max: 255 }]}
                  >
                    <Input className="form-control" />
                  </Form.Item>
                </div>
              </Col> */}
              <Col xs={24} sm={12} md={8}>
                <div className="form-group m-0">
                  {isMultiple ? (
                    <Form.Item name={['checked', 'api_group_id']} valuePropName="checked" noStyle>
                      <Checkbox>API Group</Checkbox>
                    </Form.Item>
                  ) : (
                    'API Group'
                  )}
                  <Form.Item
                    name="api_group_id"
                    className="m-0"
                    label="API Group"
                    rules={[{ required: !isMultiple }]}
                  >
                    <Select
                      allowClear
                      loading={commonLookups.spsApiGroups.loading}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option: any) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                      filterSort={(optionA: any, optionB: any) =>
                        optionA.children
                          ?.toLowerCase()
                          ?.localeCompare(optionB.children?.toLowerCase())
                      }
                    >
                      {commonLookups.spsApiGroups.data.map((option: ILookup) => (
                        <Option key={option.id} value={option.id}>
                          {option.name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <div className="form-group form-inline-pt m-0">
                  <Form.Item name="individual_field_mapping" className="m-0 mr-1" valuePropName="checked">
                    <Switch className="form-control" />
                  </Form.Item>
                  {isMultiple ? (
                    <Form.Item name={['checked', 'individual_field_mapping']} valuePropName="checked" noStyle>
                      <Checkbox>Individual Field Mapping</Checkbox>
                    </Form.Item>
                  ) : (
                    'Individual Field Mapping'
                  )}
                </div>
              </Col>
            </Row>
            <div className="btns-block modal-footer">
              <Button
                key="submit"
                type="primary"
                htmlType="submit"
                loading={spsApiType.save.loading || commonLookups.save.loading}
              >
                {submitButtonText}
              </Button>
              <Button key="back" onClick={handleModalClose}>
                Cancel
              </Button>
            </div>
          </Form>
        )}
      </Modal>
      {ShowTableMNodal && id && (
        <ApiTable
          type_id={id}
          isRadio={true}
          showModal={ShowTableMNodal}
          callApiObj={callApiObj}
          isFetchApi={true}
          is_save_api_type={true}
          setIDs={setIDs}
          handleModalClose={() => {
            setShowTableMNodal(false);
          }}
        />
      )}
    </>
  );
};
export default AddSpsApiTypeModal;
